import { BrandGoalComponent } from './brand-goal.component';

export default angular
  .module('sfMobile.components.brand-goal', [])
  .component('sfBrandGoal', BrandGoalComponent).name;
